import axios from 'axios';

const instance = axios.create({
    baseURL: process.env.VUE_APP_BACKEND_BASE_URL,
    timeout: 0,
    headers: { 'Content-Type': 'application/json' }
});

export default {
    namespaced: true,

    state: {
        status: null,
    },

    getters: {

    },

    mutations: {
        setStatus(state, status) {
            state.status = status;
        },
    },

    actions: {
        registerSchool({ commit }, payload) {

            return new Promise((resolve, reject) => {
                instance
                    .post('School/Register', payload)
                    .then((response) => {
                        commit('setStatus', 'success');
                        resolve(response);
                    })
                    .catch((error) => {
                        commit('setStatus', 'failure');
                        reject(error);
                    });
            });
        },
    },
}